import React from 'react';
import './BarraBonus.css';

/**
 * LA BARRA DEI PROGRESSI VERSO LO SBLOCCO DEL BONUS.
 *
 * Una riga sottile che si riempie man mano che si gioca. Vuole
 * `avanzamento` da utils/conto.js (avanzamentoBonus) e non disegna niente se
 * non c'è nulla da giocare. Sta nella tendina del saldo (BarraAlta) e nel
 * foglio del telefono (FogliNova): colori dalla skin, niente di proprio.
 */
export default function BarraBonus({avanzamento, testo}) {
  if (!avanzamento) return null;
  const {percentuale} = avanzamento;
  return (
    <span className={'barra-bonus'} role={'progressbar'} aria-valuemin={0} aria-valuemax={100} aria-valuenow={percentuale}
      aria-label={testo || undefined}>
      <span className={'barra-bonus-pista'}>
        <span className={'barra-bonus-pieno'} style={{width: `${percentuale}%`}}/>
      </span>
      <span className={'barra-bonus-testo'}>{testo || `${percentuale}%`}</span>
    </span>
  );
}
